import styled from 'styled-components'

export const IconAction = styled.span((props) => ({
  color: '#3C4376',
  fontSize: props.fontSize ?? '1.25rem',
  // cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
}))
